// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
  width: 85%;
  margin: 0 10% !important;
  height: 55px;
  border-radius: 12px !important;
  background: #00ab55 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  color: white !important;
  box-shadow: none !important;
}
.btn:disabled {
  background-color: #79a280 !important;
  color: white !important;
  box-shadow: none !important;
}
.outlined-btn {
  width: 85%;
  margin: 0 10% !important;
  height: 55px;
  border-radius: 12px !important;
  border: #108e24 solid 1px !important;
  color: #108e24 !important;
  font-weight: 600 !important;
  font-size: 18px !important;
  box-shadow: none !important;
}
.alignLeft {
  justify-content: left !important;
}
.d-flex {
  display: flex !important;
}
.mb30 {
  margin-bottom: 30px !important  ;
}
.css-nftsw0-MuiButtonBase-root-MuiTab-root.Mui-selecte {
  font-family: "Montserrat" !important;
  color: #00ab55 !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 22px !important;
  letter-spacing: 0px !important;
}
.css-1aquho2-MuiTabs-indicator {
  background-color: #00ab55 !important;
}
.MuiFormLabel-asterisk.MuiInputLabel-asterisk.css-wgai2y-MuiFormLabel-asterisk {
  color: red !important;
}
.fontFamily {
  font-family: "Montserrat" !important;
}
.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {
  font-family: "Montserrat" !important;
}
.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {
  font-family: "Montserrat" !important;
}
.css-ahj2mt-MuiTypography-root {
  font-family: "Montserrat" !important;
}
.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
  font-family: "Montserrat" !important;
}
.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  font-family: "Montserrat" !important;
}
.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked {
  color: #00ab55 !important;
}
.MuiBox-root.css-1r5xdm5 {
  width: 1130px !important;
}
.css-1wc848c-MuiFormHelperText-root{
  font-family: "Montserrat" !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,wBAAwB;EACxB,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oCAAoC;AACtC","sourcesContent":[".btn {\n  width: 85%;\n  margin: 0 10% !important;\n  height: 55px;\n  border-radius: 12px !important;\n  background: #00ab55 !important;\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  color: white !important;\n  box-shadow: none !important;\n}\n.btn:disabled {\n  background-color: #79a280 !important;\n  color: white !important;\n  box-shadow: none !important;\n}\n.outlined-btn {\n  width: 85%;\n  margin: 0 10% !important;\n  height: 55px;\n  border-radius: 12px !important;\n  border: #108e24 solid 1px !important;\n  color: #108e24 !important;\n  font-weight: 600 !important;\n  font-size: 18px !important;\n  box-shadow: none !important;\n}\n.alignLeft {\n  justify-content: left !important;\n}\n.d-flex {\n  display: flex !important;\n}\n.mb30 {\n  margin-bottom: 30px !important  ;\n}\n.css-nftsw0-MuiButtonBase-root-MuiTab-root.Mui-selecte {\n  font-family: \"Montserrat\" !important;\n  color: #00ab55 !important;\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 22px !important;\n  letter-spacing: 0px !important;\n}\n.css-1aquho2-MuiTabs-indicator {\n  background-color: #00ab55 !important;\n}\n.MuiFormLabel-asterisk.MuiInputLabel-asterisk.css-wgai2y-MuiFormLabel-asterisk {\n  color: red !important;\n}\n.fontFamily {\n  font-family: \"Montserrat\" !important;\n}\n.css-1jy569b-MuiFormLabel-root-MuiInputLabel-root {\n  font-family: \"Montserrat\" !important;\n}\n.css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root {\n  font-family: \"Montserrat\" !important;\n}\n.css-ahj2mt-MuiTypography-root {\n  font-family: \"Montserrat\" !important;\n}\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n  font-family: \"Montserrat\" !important;\n}\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  font-family: \"Montserrat\" !important;\n}\n.css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked {\n  color: #00ab55 !important;\n}\n.MuiBox-root.css-1r5xdm5 {\n  width: 1130px !important;\n}\n.css-1wc848c-MuiFormHelperText-root{\n  font-family: \"Montserrat\" !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
